import { ApolloError } from "apollo-boost";

const transformError = (error: any) => {
  const { extensions, ...rest } = error;
  return { ...rest, ...extensions };
};

const getDetailedGraphqlError = (errors: any[]): string => {
  const transformedErrors = transformError(errors[0]);
  const error = transformedErrors.grpcError
    ? transformedErrors.grpcError.details
    : transformedErrors.message;
  // Remove everything before ":" including the ":" itself
  // eg: "5 NOT_FOUND: This promo code is not valid" => "This promo code is not valid"
  return error.split(":").pop();
};

export const handleApolloError = (
  userFriendlyErrorMessage: string,
  apolloError?: ApolloError,
  variables?: any
) => {
  if (apolloError) {
    console.error(apolloError.message, variables);
    return userFriendlyErrorMessage;
  } else {
    return undefined;
  }
};

export default getDetailedGraphqlError;



// WEBPACK FOOTER //
// ./src/utils/errorHandling.ts